import { CarData } from "../pages/consumer/HomePage/homePageUtils";

import { atomWithStorage } from "jotai/utils";

export const carDataAtom = atomWithStorage<CarData[]>(
  "carDataAtom",
  [],
  undefined,
  { getOnInit: true }
);
